import React from 'react';
import BackgroundControls from './../../controls/background';
import PlainControls from './../../controls/plain';
import SignControls from './../../controls/sign';

class Personalize extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;

    this.onChange = this.onChange.bind(this);
    this.resetDefaultValues = this.resetDefaultValues.bind(this);
  }

  onChange(name, event) {
    this.props.onChange(name, event.target.value);
    event.preventDefault();
  }

  controls() {
    switch (this.props.template) {
      case 'background':
        return <BackgroundControls {...this.props} onChange={this.onChange} />;
      case 'plain':
        return <PlainControls {...this.props} onChange={this.onChange} />;
      case 'sign':
        return <SignControls {...this.props} onChange={this.onChange} />;
      default:
        throw new Error('Invalid template name');
    }
  }

  resetDefaultValues() {
    $('.color-control input').each((index, $control) => {
      $($control).minicolors(
        'value',
        this.props.defaults[this.props.template][$control.name],
      ); // #shame.js @TMD
    });
    this.props.resetDefaultValues();
  }

  render() {
    return (
      <div className="step-container step-four">
        <div>
          <h2>Make them your own</h2>
          {this.controls()}
          <small>
            If you get a little too adventurous with your customizations, you
            can always{' '}
            <a href="#reset-default" onClick={this.resetDefaultValues}>
              go back to using the default colors
            </a>
            .
          </small>
        </div>
      </div>
    );
  }
}

export default Personalize;
